import { Button, Grid, Typography, makeStyles } from "@material-ui/core";
import ModalAbm from "../../../compartidos/abms/ModalAbm";
import { AddEfector } from "./AddEfector";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EliminarEfectorReclamo,
  setEfectorReclamo,
} from "../../../../actions/reclamos/reclamosActions";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
  },
  switchBase: {
    color: "#bdbdbd",
    "&$checked": {
      transform: "translateX(16px)",
      color: "#4CAF50",
      "& + $track": {
        backgroundColor: "#3E8040",
        opacity: 1,
        border: "none",
      },
    },
  },
  checked: {},
  track: {},
}));

export const ModalEfectorReclamos = ({ solicitud, disabled, fechaInicio,fechaFin }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openAlta, setOpenAlta] = useState(false);
  const { efectorReclamo = {} } = useSelector((state) => state.reclamos);
  const { areasFisicasUsuario } = useSelector((state) => state.auth);


  useEffect(() => {
    dispatch(
      setEfectorReclamo(
        solicitud.idEfectorReclamo,
        solicitud.descripcionEfectorReclamo
      )
    );
  }, [dispatch]);

  const deleteEfector = () => {
    dispatch(
      EliminarEfectorReclamo(
        solicitud.id,
        efectorReclamo.idEfectorReclamo,
        areasFisicasUsuario.idArea,
        areasFisicasUsuario.idSubArea,
        fechaInicio,
        fechaFin
      )
    );
  };

  return (
    <>
      <Grid item xs={12}>
        <ModalAbm title="Agregar Efector" open={openAlta} setOpen={setOpenAlta}>
          <AddEfector
            solicitud={solicitud.id}
            cerrarModal={() => setOpenAlta(false)}
            fechaInicio={fechaInicio}
            fechaFin={fechaFin}
          />
        </ModalAbm>
        <Grid item xs={12}>
          <Button
            disabled={disabled}
            variant="contained"
            color="primary"
            onClick={() => setOpenAlta(true)}
            style={{ float: "right", marginTop: "1rem" }}
          >
            + Agregar Efector
          </Button>
        </Grid>
      </Grid>
      <Grid container justify="center" alignItems="center">
        <Grid
          item
          xs={12}
          md={12}
          style={{ display: "flex", flexDirection: "column", marginTop: 20 }}
        >
          <Typography align="center" variant="h5" color="secondary">
            <span>
              Id Efector:{" "}
              <span className={classes.title}>
                {efectorReclamo?.idEfectorReclamo}
              </span>
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{ display: "flex", flexDirection: "column", marginTop: 20 }}
        >
          <Typography align="center" variant="h5" color="secondary">
            <span>
              Nombre Efector:{" "}
              <span className={classes.title}>
                {efectorReclamo?.descripcionEfectorReclamo}
              </span>
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          md={4}
          style={{ display: "flex", flexDirection: "column", marginTop: 20 }}
        >
          <Button
            disabled={disabled}
            variant="contained"
            color="primary"
            onClick={deleteEfector}
            style={{ float: "right", marginTop: "1rem" }}
          >
            Borrar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
